// extracted by mini-css-extract-plugin
export default {"main":"EditDocument_main__OPsv+","content-wrapper":"EditDocument_content-wrapper__HXURy"};